var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-container dashboard-content-section"},[_c('h2',{staticClass:"title"},[_vm._v("My Plans")]),_c('CommonTabs',[_c('CurrentPlan'),_c('PreviousPlan')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }